import {
  Flex,
  Text,
  Button,
  useMantineTheme,
  ActionIcon,
  Box,
} from "@mantine/core";
import { useState } from "react";
import { MdClose } from "react-icons/md";
import {
  Agreement,
  GetAgreementManyQuery,
  GetClientGroupManyQuery,
} from "src/generated/graphql";
import { ModalStages } from "src/utils/constants";
import { RecursivePartial } from "src/utils/utils";

interface AgreementGroupProps {
  clientGroups: GetClientGroupManyQuery["clientGroupMany"] | [];
  clientId: string;
  selectedAgreement: RecursivePartial<Agreement> | undefined;
  setCurrentModalStage: (e: ModalStages) => void;
  setSelectedGroupId: (e: string | null) => void;
  handleModalClose: () => void;
}

const AgreementGroups = ({
  clientId,
  clientGroups,
  selectedAgreement,
  setCurrentModalStage,
  setSelectedGroupId,
  handleModalClose,
}: AgreementGroupProps) => {
  const [selectedGroup, setSelectedGroup] = useState<string | null>(null);
  const theme = useMantineTheme();

  const handleGroupSelect = (selectedGroup: string | null) => {
    const clientGroupSize = clientGroups.find((e) => e.id === selectedGroup)
      ?.clients.length;
    if (
      selectedAgreement?.limit &&
      clientGroupSize &&
      clientGroupSize >= selectedAgreement.limit
    ) {
      alert("Limit Reached");
    } else {
      setSelectedGroupId(selectedGroup);
      setCurrentModalStage(ModalStages.AGREEMENTOVERVIEW);
    }
  };
  return (
    <Flex direction={"column"}>
      <Flex direction={"column"}>
        <Flex
          align={"center"}
          justify={"space-between"}
          style={{
            paddingBottom: "10px",
            marginBottom: "10px",
            borderBottom: `2px solid ${theme.colors.light[5]}`,
          }}
        >
          <Text size={22} fw={500}>
            Select Group
          </Text>
          <ActionIcon size="lg" onClick={handleModalClose}>
            <MdClose size={20} />
          </ActionIcon>
        </Flex>

        {clientGroups?.map((group) => {
          if (group.primaryClient.id === clientId) {
            return (
              <Flex
                key={group?.id}
                justify={"space-between"}
                onClick={() => setSelectedGroup(group?.id)}
                style={{ borderBottom: `1px solid ${theme.colors.light[3]}` }}
                bg={selectedGroup === group.id ? theme.colors.light[2] : ""}
                p={10}
              >
                <Text fw={500}>{group?.name}</Text>
                <Text fw={500}>{group?.clients?.length}</Text>
              </Flex>
            );
          }
        })}
      </Flex>

      <Flex justify={"space-between"} align={"center"} mt={25}>
        <Button
          w={"45%"}
          radius="lg"
          variant="outline"
          onClick={() => setCurrentModalStage(ModalStages.AGREEMENTS)}
        >
          Back
        </Button>
        <Button
          w={"45%"}
          radius="lg"
          variant="filled"
          disabled={selectedGroup === null}
          onClick={() => {
            handleGroupSelect(selectedGroup);
          }}
        >
          Select Group
        </Button>
      </Flex>
    </Flex>
  );
};

export default AgreementGroups;
